import { render, staticRenderFns } from "./cancel.vue?vue&type=template&id=6b660638&scoped=true&lang=html&"
import script from "./cancel.vue?vue&type=script&lang=js&"
export * from "./cancel.vue?vue&type=script&lang=js&"
import style0 from "./cancel.vue?vue&type=style&index=0&id=6b660638&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b660638",
  null
  
)

export default component.exports